export default __webpack_public_path__ + "static/webtastic-107b124bbdeb3f1b077282f21731d720.png";